/**
 *  微博融合详情页
 */
'use strict';
angular.module('wbPreviewModule', ['wbPreviewRouterModule']).controller('wbPreviewCtrl', [
    '$scope',
    '$q',
    'trsHttpService',
    'editingCenterService',
    '$state',
    '$stateParams',
    'localStorageService',
    'modalDialog',
    'editingCenterWeiBoService',
    'newMediaService',
    '$element',
    '$compile',
    'weiboApiParams',
    'weiboApiService',
    'editingMediatype',
    'editcenterRightsService',
    function (
        $scope,
        $q,
        trsHttpService,
        editingCenterService,
        $state,
        $stateParams,
        localStorageService,
        modalDialog,
        editingCenterWeiBoService,
        newMediaService,
        $element,
        $compile,
        weiboApiParams,
        weiboApiService,
        editingMediatype,
        editcenterRightsService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                fromsearch: $stateParams.fromsearch,
                btnRights: {},
                isFusion: $state.current.name === 'fusionpreview',
                listOpen: 0,
                isawaitrevise: $state.params.isawaitrevise,
                fromversiontime: $state.params.fromversiontime
            };
            $scope.data = {
                copyVersion: [],
                contentCount: 0,
                records: [],
                wbInfo: {},
                operationLog: [],
                copyOperationLog: [],
                Channel: [],
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            if ($scope.status.isFusion) {
                getWbInfo();
                getVersion();
            } else {
                getVersionForWeibo();
                getWbInfoForWeibo();
            }
        }
        
        /**
         * [getDraftStage description] 获取当前稿件在哪个审核阶段（去除需要传入的wzplatform的情况，主要是从IM来的稿件）
         * @return  {[type]}  [return description]
         */
        function getDraftStage() {
            editingCenterService.getDraftStage($scope.data.wbInfo, {
                mediatype: editingMediatype.weibo,
                metadataid: $state.params.wbmetadataid
            }).then((data) => {
                $scope.status.plantform = $state.params.wbplatform = data;
                if (!$scope.status.fromversiontime){
                    getBtnRightsForWeibo();
                }
            });
        }

        /**
         * [loadDirective description]
         *
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            newMediaService.previewLoadDirective($element, $compile, $scope, '<div trs-play-audio-video adjustsize class="padding20 " ng-bind-html="data.wbInfo.HTMLCONTENT | trsSce">');
        }

        /**
         * [getBtnRightsForWeibo description] 微博渠道-获取权限
         * @return {[type]} [description]
         */
        function getBtnRightsForWeibo() {
            let platform = ['microblog.daibian', 'microblog.daishen', 'microblog.yiqianfa'][$state.params.wbplatform];
            if (!platform) {return;}
            editcenterRightsService.initWeiboListBtn(platform, $stateParams.wbchannelid).then(function (rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function (direction) {
            var pageTurningData;
            var metadataid;
            var property;
            pageTurningData = $scope.status.isFusion
                ? JSON.parse(localStorageService.get('fusionPreview'))
                : JSON.parse(localStorageService.get('wbPreview'));
            metadataid = $scope.status.isFusion ? $state.params.iwometadataid : $stateParams.wbmetadataid;
            property = $scope.status.isFusion ? 'METADATAID' : 'SCMMICROCONTENTID';
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if ((pageTurningData[i][property] ? pageTurningData[i][property] : pageTurningData[i]['METADATAID']) === metadataid) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            if ($scope.status.isFusion) {
                if ($state.params.iwomodalname === 'iwo.collect') {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.MLFID, toPageData.CHNLDOCID, toPageData.MLFTYPE, toPageData.DOCCOLLECTRELID);
                } else if ($state.params.iwomodalname === 'iwo.waste') {
                    fusionGostate(toPageData.DOCTYPE, toPageData.DOCID, toPageData.CHNLDOCID);
                } else {
                    fusionGostate(toPageData.DOCTYPEID, toPageData.METADATAID, toPageData.CHNLDOCID);
                }
            } else {
                $state.go($state.current.name, {
                    wbchannelid: toPageData.PUBLISHACCOUNTIDS || toPageData.PRODUCTID,
                    wbmetadataid: toPageData.SCMMICROCONTENTID ? toPageData.SCMMICROCONTENTID : toPageData.METADATAID
                }, {
                    reload: true
                });
            }
        };

        /**
         * [fusionGostate description] 融合采编预览页跳转
         * @param   {[type]}  doctype        [doctype description]
         * @param   {[type]}  iwometadataid  [iwometadataid description]
         * @param   {[type]}  iwochnldocid   [iwochnldocid description]
         * @param   {[type]}  mlftype        [mlftype description]
         * @param   {[type]}  collectid      [collectid description]
         * @return  {[type]}                 [return description]
         */
        function fusionGostate(doctype, iwometadataid, iwochnldocid, mlftype, collectid) {
            mlftype = !mlftype ? '' : mlftype;
            collectid = !collectid ? '' : collectid;
            var url = 'fusionpreview',
                routerParams = {
                    iwotype: doctype,
                    iwomodalname: $stateParams.iwomodalname ? $stateParams.iwomodalname : 'iwo.personal',
                    wzplatform: 0,
                    wztypeid: doctype,
                    appplatform: 0,
                    newspapertype: 2,
                    iwometadataid: iwometadataid,
                    iwochnldocid: iwochnldocid,
                    mlftype: mlftype, // 是否来自资源中心
                    iwodoccollectrelid: collectid,
                    iwoplatform: $stateParams.iwoplatform,
                };
            routerParams.appdoctype = doctype;
            if (mlftype == 0 || !mlftype) {
                // iwo
                getBindingMediaIds(iwometadataid).then(function (bingdingData) {
                    angular.forEach(bingdingData, function (value, key) {
                        if (value.MEDIATYPE == '1') {
                            routerParams.appsiteid = value.SITEID;
                            routerParams.appchannelid = value.CHANNELID;
                            routerParams.appchnldocid = value.CHNLDOCID;
                            routerParams.appmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '2') {
                            routerParams.wzsiteid = value.SITEID;
                            routerParams.wzchannelid = value.CHANNELID;
                            routerParams.wzchnldocid = value.CHNLDOCID;
                            routerParams.wzmetadataid = value.VIRTUALDOCID;
                        } else if (value.MEDIATYPE == '3') {
                            routerParams.paperid = value.CHANNELID; // 预览页与编辑页参数不同
                            routerParams.bzmetadata = value.VIRTUALDOCID; // 预览页与编辑页参数不同
                        } else if (value.MEDIATYPE == '5') {
                            routerParams.wbchannelid = value.CHANNELID;
                            routerParams.wbmetadataid = value.VIRTUALDOCID;
                        }
                    });
                    $state.go(url, routerParams, {
                        reload: true
                    }); // new
                });
            } else {
                $state.go(url, routerParams, {
                    reload: true
                }); // new
            }
        }

        /**
         * [getBindingMediaIds description] 获取绑定的渠道的相关id
         * @param {[type]} [iwometadataid] [description] iwo稿件id
         * @return {[type]} [description]
         */
        function getBindingMediaIds(iwometadataid) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryFuseMappings',
                sourceDocId: iwometadataid,
                mediaTypes: '',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                defer.resolve(data);
            });
            return defer.promise;
        }

        /**
         * [getWbInfo description] 融合渠道获取微博内容
         * @return {[type]} [description]
         */
        function getWbInfo() {
            var params = {
                methodname: 'getScmVirtualNewsDoc',
                serviceid: 'mlf_fusionmicroblog',
                sourceDocId: $state.params.iwometadataid,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                $scope.data.wbInfo = data;
                document.title = data.CONTENT;
                $scope.data.wbInfo.CONTENT = $scope.data.wbInfo.CONTENT.replace(/ /g, '&nbsp;').replace(/\n/g, '<br/>');
                $scope.data.wbInfo.PICTURE = !$scope.data.wbInfo.PICTURE ? [] : $scope.data.wbInfo.PICTURE.split(',');
                loadVersionTimePanel();
            });
        }

        /**
         * [getWbInfoForWeibo description] 微博渠道获取微博内容
         * @return {[type]} [description]
         */
        function getWbInfoForWeibo() {
            var deffer = $q.defer();
            let params = angular.extend({}, weiboApiParams.detailParams, {
                ObjectId: $stateParams.wbmetadataid,
                fromsearch: $stateParams.fromsearch
            });
            $scope.loadingPromise = weiboApiService.getDetail(params).then(function (data) {
                data.SCMMICROCONTENTID = data.SCMMICROCONTENTID || data.METADATAID;
                $scope.data.wbInfo = data;
                editingCenterService.queryVerifyDoc($scope.data.wbInfo);
                $scope.data.item = {
                    REMARKS: data.REMARKS,
                    BGAPPENDIX: data.BGAPPENDIX
                };
                document.title = data.CONTENT;
                contentCount(data.CONTENT);
                if ($scope.data.wbInfo.DOCTYPEID === '17') {
                    loadDirective();
                    loadVersionTimePanel();
                } else {
                    $scope.data.wbInfo.CONTENT = $scope.data.wbInfo.CONTENT.replace(/ /g, '&nbsp;').replace(/\n/g, '<br/>');
                    $scope.data.wbInfo.PICTURE = !$scope.data.wbInfo.PICTURE ? [] : $scope.data.wbInfo.PICTURE.split(',');
                    deffer.resolve();
                    loadVersionTimePanel();
                }
                getDraftStage();
            });
            return deffer.promise;
        }

        /**
         * [contentCount description] 内容字数统计
         * @param  {[type]} content [description]
         * @return {[type]}         [description]
         */
        function contentCount(content) {
            var replacedContent = content.replace(/\n/g, ' ');
            $scope.data.contentCount = replacedContent.length;
        }

        /**
         * [getVersion description] 获取流程记录
         * @return {[type]} [description]
         */
        function getVersion() {
            var deffer = $q.defer();
            $scope.loadingPromise = editingCenterService.getEditVersionTime($state.params.iwometadataid, $scope.page, $scope.data.copyVersion).then(
                function (data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                    $scope.data.lastVersionid = data.lastVersionid;
                    deffer.resolve();
                },
                function () {
                    deffer.resolve();
                }
            );
            return deffer.promise;
        }

        /**
         * [getVersion description]获得操作日志
         * @param   {[type]}  id  [id description]
         * @return  {[type]}      [return description]
         */
        function getVersionForWeibo() {
            var deffer = $q.defer();
            var metadataid = $stateParams.wbmetadataid;
            editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(
                function (data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    deffer.resolve();
                },
                function () {
                    deffer.resolve();
                }
            );
            return deffer.promise;
        }

        /**
         * [getLoadMore description] 操作日志点击加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getVersionForWeibo();
        };

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getVersion();
        };


        $scope.goToEdit = function () {
            var exartParams = {
                wbplatform: $state.params.wbplatform,
                wbchannelid: $state.params.wbchannelid,
                // 微博走自己的解锁方式,不走统一的
                noNeedLock: true,
                mediaType: '5'
            };
            editingCenterWeiBoService.isLock($scope.data.wbInfo.METADATAID).then((lockSituation) => {
                if (lockSituation.ISLOCK === 'false') {
                    editingCenterService.routerToEditorWithLock(angular.extend($scope.data.wbInfo, exartParams));
                } else {
                    modalDialog.alertType(
                        '当前微博已被[' + lockSituation.LOCKUSER + ']锁定，您此时不能编辑',
                        '',
                        'ask',
                        true,
                        function () {
                            editingCenterWeiBoService.forceUnlockWeibo($scope.data.wbInfo.METADATAID).then(
                                function (result) {
                                    if (result.ISSUCCESS) {
                                        editingCenterService.routerToEditorWithLock(angular.extend($scope.data.wbInfo, exartParams));
                                    }
                                },
                                function (data) {
                                    modalDialog.alertType(data.DETAIL, '', 'error', 'confirm', function () { });
                                }
                            );
                        },
                        function () { },
                        0,
                        '取消',
                        '强制解锁'
                    );
                }
            });

        };

        /**
         * [loadVersionTimePanel 动态加载流程版本信息]
         *
         * @return  {[type]}  [return description]
         */
        function loadVersionTimePanel() {
            var versionPanel =
                '<version-time-panel incoming-data="data.wbInfo"></version-time-panel>';
            versionPanel = $compile(versionPanel)($scope);
            $element.find('versionPanel').append(versionPanel);
        }
    },
]).filter('noBr', function () {
    return function (str) {
        if (str) {
            return str.replace('<br/>', '，');
        }
    };
});
